import React from 'react';
import {
    Document,
    Page,
    Text,
    Image,
    View,
    Font,
    StyleSheet,
} from '@react-pdf/renderer';
import Select from 'react-select';

const EnersysPDFComponent = props => {
    const { item, Product,ItemID, storenum, qty, PartDesc, serialNum} = props;

    const IdsArray = [];
    let count = 0;

    const styles = StyleSheet.create({

        page: {
            backgroundColor: 'white',
            marginTop: '1.27cm',
            marginBottom: '1.09cm',
            marginLeft: "0.69cm",


        },
        body: {
            width: "8.5 in",
            margin: "0 in .1875 in",
            backgroundColor: 'white',
            display: 'block',

        },
        view: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
            width: '50%',

        },
        div: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-evenly',
            width: '50%',
        }, text: {
            color: '#0081C6',
            size: '0.5rem',
            margin: "auto"
        },
        section: {
            margin: 10,
            padding: 10,
            flexGrow: 1
        },
        QRImage: {
            width: '70%',
            height: '65%',
            margin: "auto"
        },
    });

    //const resultArray = PDFImageIds.map(id => {
    //    IdsArray.push(id.BARITEMID);
    //    return document.getElementById(id.BARITEMID).toDataURL();
    //});

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                    <View style={{ display: "flex", flexDirection: "column", "flexWrap": "wrap", 'width': '100%' }}>
                        <div style={{ display: "flex", flexDirection: "row", "flexWrap": "wrap", 'width': '50%', 'outline': '2px dashed gray' }}>
                        {/*<Text style={{ width: '100%' }}>WO # :{localStorage.getItem("WONum") != null ? localStorage.getItem("WONum"): WO}</Text>*/}

                        <Text style={{ width: '100%' }}> {Product} </Text>
                        <Text style={{ width: '100%' }}> </Text>
                        <Text style={{ width: '100%' }}> </Text>
                            <Text style={{ width: '100%' }}>Store Number : {storenum}</Text>
                            <Text style={{ width: '100%' }}>Serial Number : {serialNum}</Text>
                        <Text style={{ width: '100%' }}>Enersys Part Number : {ItemID}</Text>
                            <Text style={{ width: '100%' }}>Quantity Requested : {qty}</Text>
                        <Text style={{ width: '100%' }}>Part Desc {PartDesc}</Text>
                        </div>

                    </View> 
            </Page>
        </Document>
    );
};

export default EnersysPDFComponent;